import { useEffect, useReducer, useRef, useState } from "react";
import { initDates } from "../../utils/analytics";
import {
  addCommentChat,
  addQuickReply,
  changeArea,
  changeChatCategory,
  changeName,
  changeUser,
  deleteLabels,
  deleteQuickReplies,
  editQuickReplies,
  getChatbyId,
  getScoreChat,
  saveScoreChat,
  getFilterChats,
  getLabels,
  getQuickReplies,
  orderQuickReplies,
  reactivateChatbot,
  closeConversation,
  saveLabels,
  sendFile,
  sendMessage,
  turnAbleLabel,
  toggleUnreadChat,
  toggleAnsweredChat,
  generateQuickBudget,
  createAndSendQuickBudget,
  getUserAreas,
  getUserContact,
  exportChatToAPI,
  downloadChat,
  getLabelActions,
  cancelLabelAction,
  startNewChat,
  sendContact,
  getDefaultFilters,
  setDefaultArea,
  setDefaultFilters,
  addLeadQuality,
  shareChat,
  getChatSummary,
  getAdsList,
  getCampaignsList,
  reassignLiveChat,
  getGeneralChatSettings
} from "../../services/chats";
import {
  getAreas,
  getAreasWithUsers,
  getBotState,
  getContactsArea,
} from "../../services/bot";
import { getHandOffData } from "../../services/handoff_settings";
import {
  getContactsGroups,
  getContactExternalData,
  getContactVariablesData,
  saveNewContact
} from "../../services/contacts";
import { chatReducer } from "../../reducers/chatReducer";
import { findIndexById, getDateNow, getTimeNow } from "../../utils/utils";
import { useSearchParams } from "react-router-dom";
import {
  CHAT_CATEGORIES,
  CHAT_REDUCER_ACTIONS,
  FILTER_ACTIVE_CHAT,
  FILTER_CHANNEL_CHAT,
  FILTER_ORIGIN_CHAT,
  FILTER_STATE_CHAT,
  FILTER_STATUS_CHAT,
  FILTER_TYPE_CHAT,
  FILTERS,
} from "../../constants/chats.const";
import { io } from "socket.io-client";
import { WS_URL } from "../../config/config";
import { } from "../../services/contacts";
import { showInfoToast } from "../../utils/toast";

// Stores
import { useChatDialogsStore } from "../../stores/chat/chatDialogStore";
import { useQuickReplyStore } from "../../stores/chat/quickReplyStore";
import { useContactStore } from "../../stores/chat/contactStore";
import { useAreasStore } from "../../stores/chat/areasStore";
import {
  selectOutputBufferEnabled,
  selectOutputBufferMaxMessages,
  selectOutputBufferWindowSeconds,
  useGeneralChatSettingsStore,
} from "../../stores/chat/generalSettings";

const initialState = {
  chats: { data: [], page: 1, totalPages: 1, total: 0, archivedChatsCount: 0, currentChatsCount: 0 },
  chat: { messages: [], chatInfo: null, userInfo: null },
  filterSelected: {
    initDate: "",
    endDate: "",
    chatId: "",
    username: "",
    channel: FILTER_CHANNEL_CHAT.ALL,
    type: FILTER_TYPE_CHAT.CONTACT_REQUESTS,
    state: FILTER_STATE_CHAT.ALL,
    status: FILTER_STATUS_CHAT.ALL,
    active: FILTER_ACTIVE_CHAT.ALL,
    labels: [],
    keyword: "",
    area_name: null,
    lead_score: "all",
    origin: FILTER_ORIGIN_CHAT.ALL,
    origin_data: null,
  },
  allAreas: [],
  // areasWithUsers: [],
  areas: [],
  actions_labels: [],
  contacts: [],
  // allContacts: [],
  // quickReplies: [],
  labels: [],
  mobileTab: false,
  category: CHAT_CATEGORIES.CHATS,
  states: { botState: "on", liveChat: true },
  loading: { all: true, menu: false, chat: false, newPage: false },
  dialogs: {
    // filter: false,
    // changeName: false,
    // contact: false,
    // area: false,
    // reassign: false,
    // notifications: false,
    // reactivateBot: false,
    // comment: false,
    // leadQuality: false,
    // shareChat: false,
    // disabledButtons: false,
    quickReplies: { active: false, tab: "edit" },
    labels: { active: false, tab: "all" },
    // labelInfo: false,
    // exportLeads: false,
    // confirmCloseChat: false,
    // addToContacts: false,
    // contactInfo: false,
  },
};

export function useChats(userRole) {
  const [searchParams] = useSearchParams();
  const [chatState, dispatch] = useReducer(chatReducer, initialState);
  const chatInfoRef = useRef(null);
  const categoryRef = useRef(CHAT_CATEGORIES.CHATS);

  // Chat Dialogs Store
  const closeDialog = useChatDialogsStore((state) => state.close);
  const closeFilterDialog = () => {
    closeDialog("filter");
  };

  // General Chat Settings Store
  const setGeneralChatSettings = useGeneralChatSettingsStore(
    (state) => state.setChatSettings
  );
  const outputBufferWindowSeconds = useGeneralChatSettingsStore(
    selectOutputBufferWindowSeconds
  );
  const outputBufferMaxMessages = useGeneralChatSettingsStore(
    selectOutputBufferMaxMessages
  );
  const outputBufferEnabled = useGeneralChatSettingsStore(
    selectOutputBufferEnabled
  );

  // Quick Replies Store
  const quickReplyStore = useQuickReplyStore();

  // Contact Store
  const contactStore = useContactStore();

  // Areas with Users Store
  const areasWithUsersStore = useAreasStore();

  const [userAreas, setUserAreas] = useState([]);
  const [adsList, setAdsList] = useState([]);
  const [campaignsList, setCampaignsList] = useState([]);
  const socketRef = useRef(null);
  const userAreasRef = useRef([]);
  const userContactRef = useRef([]);
  const outputBuffersRef = useRef(new Map());
  const flushOutputBufferRef = useRef(null);

  const {
    chat,
    chats,
    filterSelected,
    loading,
    category,
    areas,
    disabledButtons,
    labels,
  } = chatState;

  const filterSelectedRef = useRef(filterSelected);

  useEffect(() => {
    filterSelectedRef.current = filterSelected;
  }, [filterSelected]);

  const changeFilterQuery = (filter) => {
    const {
      initDate,
      endDate,
      chatId,
      channel,
      type,
      state,
      status,
      active,
      username,
      keyword,
      area_name,
      lead_score,
      origin,
    } = filter;
    const url = new URL(window.location.href);
    let query = [];
    if (!initDate && !endDate) query.push("dates=empty");
    if (type) query.push(`type=${type}`);
    if (username) query.push(`username=${username}`);
    if (chatId) query.push(`chat=${chatId}`);
    if (keyword) query.push(`keyword=${keyword}`);
    if (channel !== FILTER_CHANNEL_CHAT.ALL) query.push(`channel=${channel}`);
    if (state !== FILTER_STATE_CHAT.ALL) query.push(`state=${state}`);
    if (status !== FILTER_STATUS_CHAT.ALL) query.push(`status=${status}`);
    if (active !== FILTER_ACTIVE_CHAT.ALL) query.push(`active=${active}`);
    if (area_name && area_name !== "all") query.push(`area_name=${area_name}`);
    if (lead_score && lead_score !== "all") query.push(`lead_score=${lead_score}`);
    if (origin && origin !== FILTER_ORIGIN_CHAT.ALL) query.push(`origin=${origin}`);
    if (query.length > 0) url.search = query.join("&");
    window.history.replaceState({}, "", url);
  };

  const fetchData = async () => {
    dispatch({
      type: CHAT_REDUCER_ACTIONS.SET_LOADING,
      payload: { all: true },
    });
    const usernameParam = searchParams?.get("username");
    const chatParam = searchParams?.get("chat");
    const typeParam = searchParams?.get("type");
    const stateParam = searchParams?.get("state");
    const statusParam = searchParams?.get("status");
    const keywordParam = searchParams?.get("keyword");
    const areaNameParam = searchParams?.get("area_name");
    const leadScoreParam = searchParams?.get("lead_score");
    const originParam = searchParams?.get("origin");
    const channelParam = searchParams?.get("channel");
    const datesParam = searchParams?.get("dates");
    const activeParam = searchParams?.get("active");
    let date = { initDate: "", endDate: "" };
    if (!datesParam || datesParam !== "empty") {
      date = initDates(true);
    }
    let filterParams = {
      initDate: date.initDate,
      endDate: date.endDate,
      username: usernameParam ?? "",
      chatId: chatParam ?? "",
      keyword: keywordParam ?? "",
      type:
        typeParam && Object.values(FILTER_TYPE_CHAT).includes(typeParam)
          ? typeParam
          : FILTER_TYPE_CHAT.CONTACT_REQUESTS,
      active:
        activeParam && Object.values(FILTER_ACTIVE_CHAT).includes(activeParam)
          ? activeParam
          : FILTER_ACTIVE_CHAT.ALL,
      state:
        stateParam && Object.values(FILTER_STATE_CHAT).includes(stateParam)
          ? stateParam
          : FILTER_STATE_CHAT.ALL,
      status:
        statusParam && Object.values(FILTER_STATUS_CHAT).includes(statusParam)
          ? statusParam
          : FILTER_STATUS_CHAT.ALL,
      channel:
        channelParam &&
          Object.values(FILTER_CHANNEL_CHAT).includes(channelParam)
          ? channelParam
          : FILTER_CHANNEL_CHAT.ALL,
      area_name: areaNameParam ?? "all",
      lead_score: leadScoreParam ?? "all",
      origin:
        originParam && Object.values(FILTER_ORIGIN_CHAT).includes(originParam)
          ? originParam
          : FILTER_ORIGIN_CHAT.ALL,
    };

    const defaultFilters = await getDefaultFilters();
    const defaultArea = await setDefaultArea();
    const hasQueryParams =
      usernameParam ||
      chatParam ||
      typeParam ||
      stateParam ||
      statusParam ||
      keywordParam ||
      channelParam ||
      activeParam ||
      originParam;

    const filterToUse = !!hasQueryParams
      ? { ...filterParams, labels: [] }
      : {
        ...defaultFilters?.settings,
        type: defaultFilters?.settings?.type_chat || FILTER_TYPE_CHAT.ALL,
        chatId: defaultFilters?.settings?.sender_id || "",
        initDate: date.initDate,
        endDate: date.endDate,
        origin: defaultFilters?.settings?.origin || FILTER_ORIGIN_CHAT.ALL,
      };

    const [
      qr,
      lbls,
      data,
      botState,
      handoffData,
      userAreasData,
      userContact,
      allAreas,
      areasWithUsers,
      adsData,
      campaignsData,
      generalChatSettings,
    ] = await Promise.all([
      getQuickReplies(),
      getLabels(),
      getFilterChats({
        ...filterToUse,
        category: CHAT_CATEGORIES.CHATS,
        page: 1,
      }),
      getBotState(),
      getHandOffData(),
      getUserAreas(),
      getUserContact(),
      getAreas(),
      getAreasWithUsers(),
      getAdsList(),
      getCampaignsList(),
      getGeneralChatSettings(),
    ]);

    setUserAreas(userAreasData);
    setAdsList(adsData);
    setCampaignsList(campaignsData);

    userAreasRef.current = userAreasData;
    userContactRef.current = userContact;

    quickReplyStore.setQuickReplies(qr ?? []);
    areasWithUsersStore.setAreasWithUsers(areasWithUsers ?? []);
    setGeneralChatSettings(generalChatSettings);

    changeFilterQuery(filterToUse);

    dispatch({
      type: CHAT_REDUCER_ACTIONS.INIT_STATES,
      payload: {
        filterSelected: {
          ...filterSelected,
          ...filterToUse,
        },
        state: {
          botState: botState?.botState ?? "off",
          liveChat: handoffData?.form_handoff_mode ?? false,
        },
        // quickReplies: qr ?? [],
        labels: lbls ?? [],
        // allContacts: contacts,
        allAreas: allAreas ?? [],
        // areasWithUsers: areasWithUsers ?? [],
        chats: {
          data: data?.data ?? [],
          page: 1,
          totalPages: data?.total_pages ?? 1,
          total: data?.total_chats ?? 0,
          archivedChatsCount: data?.chats_counts?.archived ?? 0,
          currentChatsCount: data?.chats_counts?.current ?? 0,
        },
      },
    });
    dispatch({
      type: CHAT_REDUCER_ACTIONS.SET_LOADING,
      payload: { all: false },
    });
    getLabelActionsOptions();
    getContactsGroupsOptions();
  };

  const saveContact = async (contactData) => {
    const res = await saveNewContact(contactData);
    return res;
  };

  const getLabelActionsOptions = async () => {
    let data = { labels_actions: [] };
    const resLabelActions = await getLabelActions();
    let actions = [];

    // Agregar "Sin acción asociada" al principio
    actions.push({
      label: "Sin acción asociada",
      value: null,
      type: "",
    });

    if (resLabelActions) {
      actions = [
        ...actions, // Mantener "Sin acción asociada" al principio
        ...resLabelActions.map((c) => {
          return {
            label: c.title,
            value: c.id,
            type: c.type,
          };
        }),
      ];
    }

    data.labels_actions = actions;

    dispatch({
      type: CHAT_REDUCER_ACTIONS.SET_ACTIONS_LABELS,
      payload: data,
    });
  };

  const getContactsGroupsOptions = async () => {
    let data = { contacts_groups: [] };
    const resContactsGroups = await getContactsGroups();
    let contactsGroups = [];

    if (resContactsGroups) {
      contactsGroups = [
        ...contactsGroups, // Mantener "Sin acción asociada" al principio
        ...resContactsGroups.map((c) => {
          return {
            label: c.company_name,
            value: c.company_id,
          };
        }),
      ];
    }

    data.contacts_groups = contactsGroups;

    dispatch({
      type: CHAT_REDUCER_ACTIONS.SET_CONTACTS_GROUPS,
      payload: data,
    });
  };
  const saveDefaultFilters = async (filters) => {
    const res = await setDefaultFilters(filters);
  };

  const getContactDataRequest = async (external_id, api_service) => {
    const res = await getContactExternalData(external_id, api_service);
    if (Array.isArray(res)) {
      const externalVariables = res.map((item) => ({
        ...item,
        slot_value: item.external_value,
      }));
      dispatch({
        type: CHAT_REDUCER_ACTIONS.UPDATE_USER_INFO,
        payload: { external_variables: externalVariables },
      });
    }
  };

  const getContactVariablesRequest = async (contact_id, sender_id, api_service) => {
    const res = await getContactVariablesData(contact_id, sender_id, api_service);
    if (Array.isArray(res)) {
      dispatch({
        type: CHAT_REDUCER_ACTIONS.UPDATE_USER_INFO,
        payload: { user_variables: res },
      });
    }
  };

  const getAreasAndContacts = async (datamsg) => {
    let data = { areas: [], contacts: [] };
    const resAreas = await getAreas();
    let obj = [];
    if (resAreas) {
      obj = resAreas.map((c) => {
        return {
          label: c.name,
          value: c.id,
          handoff: c.enable_handoff,
        };
      });
    }
    // obj.push({
    //   label: "Sin área signada",
    //   value: "",
    //   handoff: true,
    // });
    data.areas = obj;

    let contacts = [];
    if (datamsg.contact_data && datamsg.contact_data.area_id) {
      const resContacts = await getContactsArea(datamsg.contact_data.area_id);
      if (resContacts) {
        contacts = resContacts.map((c) => {
          return {
            label: c.name,
            value: c.id,
          };
        });
      }
    }
    contacts.push({
      label: "Sin contacto asignado",
      value: "none",
    });
    data.contacts = contacts;
    dispatch({
      type: CHAT_REDUCER_ACTIONS.SET_AREAS_AND_CONTACTS,
      payload: data,
    });
  };

  const [scoreChat, setScoreChat] = useState(null);

  const handleGetScoreChat = async (chatId) => {
    let data = await getScoreChat(chatId);
    setScoreChat(data?.score_data || null);
  }

  const handleSaveScoreChat = async (chatId) => {
    let data = await saveScoreChat(chatId, scoreChat);
  }

  const handleGetChatById = async (chatToGet, callAreasandContacts = false) => {
    let datamsg = await getChatbyId(chatToGet);
    if (datamsg && datamsg !== "canceled") {
      callAreasandContacts && getAreasAndContacts(datamsg);
      dispatch({
        type: CHAT_REDUCER_ACTIONS.SET_CHAT,
        payload: {
          chatInfo: {
            ...chatToGet,
            summary: datamsg.contact_data?.summary ?? datamsg.summary ?? null,
          },
          userInfo: datamsg.contact_data,
          messages: datamsg.data,
        },
      });
      return true;
    }
    return false;
  };
  const selectChat = async (chatToSelect) => {
    if (chatToSelect?.id !== chat.chatInfo?.id) {
      dispatch({ type: CHAT_REDUCER_ACTIONS.CLEAR_CHAT });

      dispatch({
        type: CHAT_REDUCER_ACTIONS.SET_LOADING,
        payload: { chat: true },
      });
      if (await handleGetChatById(chatToSelect, true)) {
        let index = chats.data.findIndex((e) => e.id === chatToSelect.id);
        chatInfoRef.current = chatToSelect;

        if (
          index !== -1 &&
          !chats.data[index].open &&
          userRole?.name !== "Soporte"
        ) {
          let _chats = [...chats.data];
          _chats[index].open = true;
          dispatch({
            type: CHAT_REDUCER_ACTIONS.SET_CHATS,
            payload: { ...chats, data: _chats },
          });
        }
        dispatch({ type: CHAT_REDUCER_ACTIONS.OPEN_MOBILE_TAB });
      }
      dispatch({
        type: CHAT_REDUCER_ACTIONS.SET_LOADING,
        payload: { chat: false },
      });
    }
  };

  const selectCategory = async (category) => {
    dispatch({
      type: CHAT_REDUCER_ACTIONS.SET_LOADING,
      payload: { menu: true },
    });
    chatInfoRef.current = null;
    dispatch({ type: CHAT_REDUCER_ACTIONS.CLEAR_CHAT });
    const data = await getFilterChats({
      ...filterSelected,
      category: category,
      page: 1,
    });
    if (data?.data) {
      categoryRef.current = category;
      dispatch({
        type: CHAT_REDUCER_ACTIONS.CHANGE_CATEGORY,
        payload: { category: category },
      });
      dispatch({
        type: CHAT_REDUCER_ACTIONS.SET_CHATS,
        payload: {
          data: data.data,
          page: 1,
          totalPages: data.total_pages,
          total: data.total_chats,
          currentChatsCount: data.chats_counts.current,
          archivedChatsCount: data.chats_counts.archived,
        },
      });
    }
    dispatch({
      type: CHAT_REDUCER_ACTIONS.SET_LOADING,
      payload: { menu: false },
    });
  };

  const filterChats = async (filter) => {
    dispatch({
      type: CHAT_REDUCER_ACTIONS.SET_LOADING,
      payload: { menu: true },
    });

    chatInfoRef.current = null;
    dispatch({ type: CHAT_REDUCER_ACTIONS.CLEAR_CHAT });

    closeFilterDialog();

    const newFilter = {
      ...filter,
      category: category,
      page: 1,
    };
    let res = await getFilterChats(newFilter);
    if (res) {
      dispatch({
        type: CHAT_REDUCER_ACTIONS.SET_CHATS,
        payload: {
          data: res.data,
          page: 1,
          totalPages: res.total_pages,
          total: res.total_chats,
          currentChatsCount: res.chats_counts.current,
          archivedChatsCount: res.chats_counts.archived,
        },
      });
      dispatch({
        type: CHAT_REDUCER_ACTIONS.SET_FILTER_SELECTED,
        payload: {
          initDate: filter.initDate,
          endDate: filter.endDate,
          channel: filter.channel,
          type: filter.type,
          username: filter.username,
          chatId: filter.chatId,
          keyword: filter.keyword,
          area_name: filter.area_name,
          lead_score: filter.lead_score,
          origin: filter.origin,
          origin_data:
            filter.origin === FILTER_ORIGIN_CHAT.AD || filter.origin === FILTER_ORIGIN_CHAT.CAMPAIGN
              ? filter.origin_data
              : null,
          state: filter.state,
          active: filter.active,
          status: filter.status,
          labels: filter.labels,
        },
      });
      changeFilterQuery(newFilter);
    }
    dispatch({
      type: CHAT_REDUCER_ACTIONS.SET_LOADING,
      payload: { menu: false },
    });
  };

  const removeFilter = async (removeType, id = "") => {
    const {
      endDate,
      initDate,
      channel,
      state,
      status,
      labels,
      type,
      chatId,
      username,
      active,
      keyword,
      area_name,
      lead_score,
      origin,
    } = filterSelected;

    dispatch({
      type: CHAT_REDUCER_ACTIONS.SET_LOADING,
      payload: { menu: true },
    });
    chatInfoRef.current = null;
    dispatch({ type: CHAT_REDUCER_ACTIONS.CLEAR_CHAT });
    const newFilter = {
      initDate: removeType === FILTERS.DATE ? "" : initDate,
      endDate: removeType === FILTERS.DATE ? "" : endDate,
      type: removeType === FILTERS.TYPE ? FILTER_TYPE_CHAT.ALL : type,
      username: removeType === FILTERS.USERNAME ? "" : username,
      chatId: removeType === FILTERS.CHAT_ID ? "" : chatId,
      keyword: removeType === FILTERS.KEYWORD ? "" : keyword,
      area_name: removeType === FILTERS.AREA_NAME ? "all" : area_name,
      lead_score: removeType === FILTERS.LEAD_SCORE ? "all" : lead_score,
      origin: removeType === FILTERS.ORIGIN ? FILTER_ORIGIN_CHAT.ALL : origin,
      origin_data: removeType === FILTERS.ORIGIN ? null : filterSelected.origin_data,
      state: removeType === FILTERS.STATE ? FILTER_STATE_CHAT.ALL : state,
      active: removeType === FILTERS.ACTIVE ? FILTER_ACTIVE_CHAT.ALL : active,
      status: removeType === FILTERS.STATUS ? FILTER_STATUS_CHAT.ALL : status,
      labels:
        removeType === FILTERS.LABEL ? labels.filter((c) => c !== id) : labels,
      channel:
        removeType === FILTERS.CHANNEL ? FILTER_CHANNEL_CHAT.ALL : channel,
      category: category,
      page: 1,
    };

    let res = await getFilterChats(newFilter);
    if (res) {
      dispatch({
        type: CHAT_REDUCER_ACTIONS.SET_FILTER_SELECTED,
        payload: newFilter,
      });
      dispatch({
        type: CHAT_REDUCER_ACTIONS.SET_CHATS,
        payload: {
          data: res.data,
          page: 1,
          totalPages: res.total_pages,
          total: res.total_chats,
          currentChatsCount: res.chats_counts.current,
          archivedChatsCount: res.chats_counts.archived,
        },
      });
      changeFilterQuery(newFilter);
    }

    dispatch({
      type: CHAT_REDUCER_ACTIONS.SET_LOADING,
      payload: { menu: false },
    });
  };

  const loadNewChatPage = async (newPage) => {
    if (!loading.menu && !loading.all && newPage <= chats.totalPages) {
      dispatch({
        type: CHAT_REDUCER_ACTIONS.SET_LOADING,
        payload: { newPage: true },
      });
      const data = await getFilterChats({
        ...filterSelected,
        category: category,
        page: newPage,
      });
      if (data) {
        dispatch({
          type: CHAT_REDUCER_ACTIONS.SET_CHATS,
          payload: {
            data: data.data,
            page: newPage,
            totalPages: data.total_pages,
            total: data.total_chats,
            currentChatsCount: data.chats_counts.current,
            archivedChatsCount: data.chats_counts.archived,
          },
        });
      }
      dispatch({
        type: CHAT_REDUCER_ACTIONS.SET_LOADING,
        payload: { newPage: false },
      });
    }
  };

  const reactivateBot = async (chatToActivate) => {
    const res = await reactivateChatbot(chatToActivate);
    if (res) {
      let index = chats.data.findIndex((e) => e.id === chat.chatInfo.id);
      if (index !== -1) {
        let _chats = [...chats.data];
        _chats[index].live = false;
        dispatch({
          type: CHAT_REDUCER_ACTIONS.UPDATE_CHAT_INFO,
          payload: { live: false },
        });
        dispatch({
          type: CHAT_REDUCER_ACTIONS.SET_CHATS,
          payload: { ...chats, data: _chats },
        });
      }
    }
  };

  const closeChat = async (chatToClose) => {
    console.log("Closing chat:", chatToClose);
    const res = await closeConversation(chatToClose);
    if (res) {
      dispatch({ type: CHAT_REDUCER_ACTIONS.SET_CLOSED_CHAT });
      if (res.state !== 2) {
        await changeCategory(chatToClose, "resueltas");
      }
    }
  };

  const changeCategory = async (chat, newcategory) => {
    dispatch({
      type: CHAT_REDUCER_ACTIONS.SET_LOADING,
      payload: { chat: true },
    });
    dispatch({ type: CHAT_REDUCER_ACTIONS.CLOSE_MOBILE_TAB });
    chatInfoRef.current = null;
    dispatch({ type: CHAT_REDUCER_ACTIONS.CLEAR_CHAT });
    const res = await changeChatCategory(chat, newcategory);
    if (res) {
      let _chats = [...chats.data];
      _chats = _chats.filter((d) => d.id !== chat.id);

      let _currentCount = chats.currentChatsCount;
      let _archivedCount = chats.archivedChatsCount;
      let _total = chats.total;

      if (newcategory === "nuevas") {
        _currentCount += 1;
        _archivedCount = Math.max(0, _archivedCount - 1);
      }

      if (newcategory === "resueltas") {
        _currentCount = Math.max(0, _currentCount - 1);
        _archivedCount += 1;
      }

      // Actualizar total en función de la categoría actual
      _total = Math.max(0, _total - 1);

      dispatch({
        type: CHAT_REDUCER_ACTIONS.SET_CHATS,
        payload: {
          ...chats,
          data: _chats,
          total: _total,
          currentChatsCount: _currentCount,
          archivedChatsCount: _archivedCount,
        },
      });
    }
    dispatch({
      type: CHAT_REDUCER_ACTIONS.SET_LOADING,
      payload: { chat: false },
    });
  };

  const renameChat = async (chatToEdit, name) => {
    const res = await changeName(chatToEdit, name);
    if (res) {
      let index = findIndexById(chats.data, chatToEdit.id);
      if (index !== -1) {
        let _chats = [...chats.data];
        _chats[index].user_name = name;
        dispatch({
          type: CHAT_REDUCER_ACTIONS.SET_CHATS,
          payload: { ...chats, data: _chats },
        });
        dispatch({
          type: CHAT_REDUCER_ACTIONS.SET_CHAT,
          payload: {
            ...chat,
            chatInfo: { ...chat.chatInfo, user_name: name },
            userInfo: { ...chat.userInfo, name: name },
          },
        });
      }
    }
  };

  const saveChangeArea = async (areaSelected, chatInfoToEdit) => {
    const {
      endDate,
      initDate,
      channel,
      state,
      status,
      labelsSelected,
      active,
      type,
      keyword,
      lead_score
    } = filterSelected;
    const res = await changeArea(areaSelected, chatInfoToEdit);
    if (res) {
      const data = await getFilterChats({
        endDate: endDate,
        initDate: initDate,
        type: type,
        category: category,
        channel: channel,
        active: active,
        keyword: keyword,
        chatId: "",
        username: "",
        area_name: filterSelectedRef.current?.area_name || "all",
        state: state,
        status: status,
        labels: labelsSelected,
        page: chats.page,
        lead_score: lead_score
      });
      if (data) {
        dispatch({
          type: CHAT_REDUCER_ACTIONS.SET_CHATS,
          payload: {
            data: data.data,
            page: chats.page,
            totalPages: data.total_pages,
            total: data.total_chats,
            currentChatsCount: data.chats_counts.current,
            archivedChatsCount: data.chats_counts.archived,
          },
        });
        if (data?.data?.length > 0) {
          const newChatInfo = data.data.find(
            (element) => element.id === chatInfoToEdit.id
          );
          if (newChatInfo) {
            const area = areas.find((a) => a.value == areaSelected);
            let _userInfo = { ...chat.userInfo };
            _userInfo.area = area.label;
            _userInfo.area_id = area.value;
            _userInfo.employee = "Sín usuario asignado";
            _userInfo.employee_id = null;

            let _chatInfo = { ...chatInfoToEdit };
            _chatInfo.area = area.label;
            _chatInfo.assign_user = "";

            getAreasAndContacts({ contact_data: _userInfo });
          } else {
            chatInfoRef.current = null;
            dispatch({ type: CHAT_REDUCER_ACTIONS.CLEAR_CHAT });
          }
        } else {
          chatInfoRef.current = null;
          dispatch({ type: CHAT_REDUCER_ACTIONS.CLEAR_CHAT });
        }
      }
    }
  };
  const saveChangeContact = async (chat, userId) => {
    const {
      endDate,
      initDate,
      channel,
      state,
      status,
      labels,
      type,
      active,
      keyword,
      lead_score
    } = filterSelected;
    const res = await changeUser(chat, userId);
    if (res) {
      const data = await getFilterChats({
        initDate,
        endDate,
        type: type,
        category: category,
        channel: channel,
        active: active,
        keyword: keyword,
        chatId: "",
        area_name: "",
        username: "",
        state: state,
        status: status,
        labels: labels,
        page: chats.page,
        lead_score: lead_score
      });
      if (data) {
        dispatch({
          type: CHAT_REDUCER_ACTIONS.SET_CHATS,
          payload: {
            data: data.data,
            page: chats.page,
            totalPages: data.total_pages,
            total: data.total_chats,
            currentChatsCount: data.chats_counts.current,
            archivedChatsCount: data.chats_counts.archived,
          },
        });
        if (data?.data?.length > 0) {
          const newChatInfo = data.data.find(
            (element) => element.id === chat.id
          );
          if (newChatInfo) {
            await handleGetChatById(newChatInfo);
          } else {
            chatInfoRef.current = null;
            dispatch({ type: CHAT_REDUCER_ACTIONS.CLEAR_CHAT });
          }
        } else {
          chatInfoRef.current = null;
          dispatch({ type: CHAT_REDUCER_ACTIONS.CLEAR_CHAT });
        }
      }
    }
  };

  const saveReassignChat = async (chatInfoToEdit, areaId, userId) => {
    const {
      endDate,
      initDate,
      channel,
      state,
      status,
      labels,
      type,
      active,
      keyword,
      lead_score
    } = filterSelected;

    const res = await reassignLiveChat(chatInfoToEdit, areaId, userId);
    if (res) {
      const data = await getFilterChats({
        initDate,
        endDate,
        type,
        category,
        channel,
        active,
        keyword,
        chatId: "",
        area_name: "",
        username: "",
        state,
        status,
        labels,
        page: chats.page,
        lead_score,
      });

      if (data) {
        dispatch({
          type: CHAT_REDUCER_ACTIONS.SET_CHATS,
          payload: {
            data: data.data,
            page: chats.page,
            totalPages: data.total_pages,
            total: data.total_chats,
            currentChatsCount: data.chats_counts.current,
            archivedChatsCount: data.chats_counts.archived,
          },
        });

        if (data?.data?.length > 0) {
          const newChatInfo = data.data.find(
            (element) => element.id === chatInfoToEdit.id
          );
          if (newChatInfo) {
            await handleGetChatById(newChatInfo);
          } else {
            chatInfoRef.current = null;
            dispatch({ type: CHAT_REDUCER_ACTIONS.CLEAR_CHAT });
          }
        } else {
          chatInfoRef.current = null;
          dispatch({ type: CHAT_REDUCER_ACTIONS.CLEAR_CHAT });
        }
      }
    }
  };

  const addChatComment = async (chatSelected, message) => {
    await addCommentChat(chatSelected, message);
  };

  const shareChatToContact = async (chatSelected, data) => {
    await shareChat(chatSelected, data);
  }

  const generateChatSummary = async (chatSelected, options = {}) => {
    const result = await getChatSummary(chatSelected, options);
    return result;
  }

  const addLeadQualityScore = async (chatSelected, value) => {
    const score_value = await addLeadQuality(chatSelected, value);
    dispatch({ type: CHAT_REDUCER_ACTIONS.SET_LEAD_QUALITY_SCORE, payload: score_value });
  };

  const checkUnreadChat = async (chatInfoSelected) => {
    let res = await toggleUnreadChat(chatInfoSelected);
    if (res) {
      let index = chats.data.findIndex((e) => e.id === chatInfoSelected.id);
      if (index !== -1) {
        let _chats = [...chats.data];
        _chats[index].open = !_chats[index]?.open;
        dispatch({
          type: CHAT_REDUCER_ACTIONS.UPDATE_CHAT_INFO,
          payload: _chats[index],
        });
        dispatch({
          type: CHAT_REDUCER_ACTIONS.SET_CHATS,
          payload: { ...chats, data: _chats },
        });
      }
    }
  };
  const checkAnsweredChat = async (chatInfoSelected) => {
    let res = await toggleAnsweredChat(chatInfoSelected);
    if (res) {
      let index = chats.data.findIndex((e) => e.id === chatInfoSelected.id);
      if (index !== -1) {
        let _chats = [...chats.data];
        _chats[index].answered = !_chats[index]?.answered;
        dispatch({
          type: CHAT_REDUCER_ACTIONS.UPDATE_CHAT_INFO,
          payload: _chats[index],
        });
        dispatch({
          type: CHAT_REDUCER_ACTIONS.SET_CHATS,
          payload: { ...chats, data: _chats },
        });
      }
    }
  };

  const exportChatLeads = async (chatInfo, summary = null) => {
    const res = await exportChatToAPI(chatInfo.id, summary);
    return res;
  };

  const downloadSelectedChat = async (chatInfo) => {
    await downloadChat(chatInfo.id);
  };

  const changeChatInfo = (user = "", message = "", file = false) => {
    let index = findIndexById(chats.data, chat.chatInfo.id);
    if (index !== -1) {
      let _chatsData = [...chats.data];
      _chatsData[index].last_message_text = file ? "Archivo" : message;
      _chatsData[index].last_message_from = user;
      _chatsData[index].live = true;
      _chatsData[index].type = "live";
      dispatch({
        type: CHAT_REDUCER_ACTIONS.SET_CHATS,
        payload: { ...chats, data: _chatsData },
      });
      dispatch({
        type: CHAT_REDUCER_ACTIONS.UPDATE_CHAT_INFO,
        payload: { type: "live", live: true },
      });
    }
  };

  const initNewChat = async (data) => {
    if (disabledButtons) return;
    dispatch({ type: CHAT_REDUCER_ACTIONS.CHANGE_DISABLED_BUTTONS });
    const res = await startNewChat(data);
    dispatch({ type: CHAT_REDUCER_ACTIONS.CHANGE_DISABLED_BUTTONS });
    return res;
  };

  const getSentMessageIdentifiers = (response) => {
    if (!response || typeof response !== "object") {
      return { messageId: null, internalId: null };
    }

    const messageId =
      response.message_id ??
      response?.message?.message_id ??
      response?.sent_message?.message_id ??
      null;

    const internalId =
      response.id ??
      response?.message?.id ??
      response?.sent_message?.id ??
      null;

    return { messageId, internalId };
  };

  const createOptimisticTextMessage = (
    chatSelected,
    message,
    targetedMessageId,
    optimisticMessageId = `tmp-msg-${Date.now()}-${Math.random()
      .toString(36)
      .slice(2, 8)}`
  ) => {
    dispatch({
      type: CHAT_REDUCER_ACTIONS.ADD_OPTIMISTIC_MESSAGE,
      payload: {
        message: {
          id: optimisticMessageId,
          type: "bot",
          value: message,
          date: getDateNow(),
          time: getTimeNow(),
          message_status: "sending",
          target_message_id: targetedMessageId || null,
          optimistic: true,
        },
      },
    });
    changeChatInfo("bot", message, false);
    return optimisticMessageId;
  };

  const updateOptimisticTextStatus = (optimisticMessageId, response) => {
    if (response) {
      const { messageId, internalId } = getSentMessageIdentifiers(response);
      dispatch({
        type: CHAT_REDUCER_ACTIONS.UPDATE_OPTIMISTIC_MESSAGE,
        payload: {
          message_id: optimisticMessageId,
          data: {
            message_status: "sent",
            ...(messageId ? { message_id: messageId } : {}),
            ...(internalId ? { server_id: internalId } : {}),
          },
        },
      });
    } else {
      dispatch({
        type: CHAT_REDUCER_ACTIONS.UPDATE_OPTIMISTIC_MESSAGE,
        payload: {
          message_id: optimisticMessageId,
          data: {
            message_status: "failed",
            code: "ERROR_LOCAL_SEND",
          },
        },
      });
    }
  };

  const sendTextImmediately = async ({
    chatSelected,
    message,
    targetedMessageId,
    generated,
    clearInputs,
  }) => {
    if (!message) return null;

    const optimisticMessageId = createOptimisticTextMessage(
      chatSelected,
      message,
      targetedMessageId
    );
    clearInputs?.();
    const response = await sendMessage(
      chatSelected,
      message,
      targetedMessageId,
      generated
    );
    updateOptimisticTextStatus(optimisticMessageId, response);
    return response;
  };

  const flushOutputBuffer = async (bufferKey) => {
    const buffer = outputBuffersRef.current.get(bufferKey);
    if (!buffer) return null;

    clearTimeout(buffer.timeoutId);
    outputBuffersRef.current.delete(bufferKey);

    const combinedMessage = buffer.messages.join("\n");
    const response = await sendMessage(
      buffer.chatSelected,
      combinedMessage,
      buffer.targetedMessageId,
      buffer.generated
    );
    updateOptimisticTextStatus(buffer.optimisticMessageId, response);
    return response;
  };

  flushOutputBufferRef.current = flushOutputBuffer;

  useEffect(() => {
    if (!outputBufferEnabled) {
      [...outputBuffersRef.current.keys()].forEach((key) => {
        flushOutputBufferRef.current?.(key);
      });
    }
  }, [outputBufferEnabled]);

  useEffect(() => () => {
    [...outputBuffersRef.current.keys()].forEach((key) => {
      flushOutputBufferRef.current?.(key);
    });
  }, []);

  const sendNewChatMessage = async (
    chatSelected,
    message,
    inputFiles,
    audio,
    contact,
    targetedMessage,
    clearInputs,
    generated = null,
  ) => {
    const shouldLockSend = inputFiles.length > 0 || audio || contact;
    const bufferKey = `${localStorage.getItem("bot") || ""}:${chatSelected?.id}`;

    if (shouldLockSend) {
      dispatch({ type: CHAT_REDUCER_ACTIONS.CHANGE_DISABLED_BUTTONS });
    }

    if (inputFiles.length > 0 || audio) {
      await flushOutputBuffer(bufferKey);

      const res = await sendFile(
        chatSelected,
        inputFiles,
        audio,
        targetedMessage?.id,
        message
      );
      if (res) clearInputs();

      if (shouldLockSend) {
        dispatch({ type: CHAT_REDUCER_ACTIONS.CHANGE_DISABLED_BUTTONS });
      }
      return;
    }
    if (contact) {
      if (outputBufferEnabled) await flushOutputBuffer(bufferKey);
      const res = await sendContact(
        chatSelected,
        contact.value,
        targetedMessage?.id
      );

      if (res) clearInputs();

      if (shouldLockSend) {
        dispatch({ type: CHAT_REDUCER_ACTIONS.CHANGE_DISABLED_BUTTONS });
      }
      return;
    } else {
      if (message !== "") {

        if (/{{\s*[^{}]+\s*}}/.test(message)) {
          showInfoToast("El mensaje contiene variables cuyos valores no han sido asignados correctamente. Si no estas intentando usar variables, recuerda que el uso del formato {{texto}} está reservado.");
          return;
        }

        if (!outputBufferEnabled) {
          await sendTextImmediately({
            chatSelected,
            message,
            targetedMessageId: targetedMessage?.id,
            generated,
            clearInputs,
          });
          return;
        }

        let buffer = outputBuffersRef.current.get(bufferKey);
        if (!buffer) {
          const optimisticMessageId = createOptimisticTextMessage(
            chatSelected,
            message,
            targetedMessage?.id
          );
          buffer = {
            chatSelected,
            messages: [message],
            optimisticMessageId,
            targetedMessageId: targetedMessage?.id,
            generated,
            timeoutId: null,
          };
          outputBuffersRef.current.set(bufferKey, buffer);
          buffer.timeoutId = setTimeout(
            () => flushOutputBufferRef.current?.(bufferKey),
            outputBufferWindowSeconds * 1000
          );
        } else {
          buffer.messages.push(message);
          dispatch({
            type: CHAT_REDUCER_ACTIONS.UPDATE_OPTIMISTIC_MESSAGE,
            payload: {
              message_id: buffer.optimisticMessageId,
              data: { value: buffer.messages.join("\n") },
            },
          });
          changeChatInfo("bot", buffer.messages.join("\n"), false);
        }

        clearInputs();

        if (
          Number.isFinite(outputBufferMaxMessages) &&
          outputBufferMaxMessages > 0 &&
          buffer.messages.length >= outputBufferMaxMessages
        ) {
          await flushOutputBuffer(bufferKey);
        }
      }
    }

  };

  const retryFailedMessage = async (failedMessage) => {
    if (
      !failedMessage ||
      !failedMessage.id ||
      !failedMessage.value ||
      disabledButtons
    ) {
      return;
    }

    dispatch({ type: CHAT_REDUCER_ACTIONS.CHANGE_DISABLED_BUTTONS });

    dispatch({
      type: CHAT_REDUCER_ACTIONS.UPDATE_OPTIMISTIC_MESSAGE,
      payload: {
        message_id: failedMessage.id,
        data: {
          message_status: "sending",
          code: null,
        },
      },
    });

    const res = await sendMessage(
      chat.chatInfo,
      failedMessage.value,
      failedMessage.target_message_id || null,
      null
    );

    if (res) {
      const { messageId, internalId } = getSentMessageIdentifiers(res);

      dispatch({
        type: CHAT_REDUCER_ACTIONS.UPDATE_OPTIMISTIC_MESSAGE,
        payload: {
          message_id: failedMessage.id,
          data: {
            message_status: "sent",
            ...(messageId ? { message_id: messageId } : {}),
            ...(internalId ? { server_id: internalId } : {}),
          },
        },
      });
    } else {
      dispatch({
        type: CHAT_REDUCER_ACTIONS.UPDATE_OPTIMISTIC_MESSAGE,
        payload: {
          message_id: failedMessage.id,
          data: {
            message_status: "failed",
            code: "ERROR_LOCAL_SEND",
          },
        },
      });
    }

    dispatch({ type: CHAT_REDUCER_ACTIONS.CHANGE_DISABLED_BUTTONS });
  };

  const saveQuickReply = async (newQuickReply, type) => {
    if (type === "new") {
      const added_qr = await addQuickReply(newQuickReply);
      // No es necesario porque se notifica el cambio al websocket.
      // if (added_qr) { quickReplyStore.add(added_qr); }
    } else if (type === "edit2") {
      const edited_qr = await editQuickReplies(newQuickReply);
      // No es necesario porque se notifica el cambio al websocket.
      // if (edited_qr) { quickReplyStore.update(edited_qr); }
    }
  };

  const saveQuickReplyOrder = (e) => {
    orderQuickReplies(e.value);
    // No es necesario porque se notifica el cambio al websocket.
    // quickReplyStore.setQuickReplies(e.value);
  };

  const deleteQuickReply = async (data) => {
    const res = await deleteQuickReplies(data);
    // No es necesario porque se notifica el cambio al websocket.
    // if (res) { quickReplyStore.remove(data.id); }
  };

  const toggleLabelActionStatus = async (chatId, labelId) => {
    const res = await cancelLabelAction(chatId, labelId);
    if (res) {
      let editedLabels = [...chat.userInfo.labels];
      const index = findIndexById(editedLabels, labelId);
      if (index !== -1) {
        editedLabels[index] = { ...editedLabels[index], ...res.edited_label };
        dispatch({
          type: CHAT_REDUCER_ACTIONS.UPDATE_USER_INFO,
          payload: { labels: editedLabels },
        });
        dispatch({
          type: CHAT_REDUCER_ACTIONS.UPDATE_CHAT_INFO,
          payload: { labels: editedLabels },
        });
      }
      let indexChat = findIndexById(chats.data, chatId);
      if (indexChat !== -1) {
        let c = [...chats.data];
        c[indexChat].labels = editedLabels;
        dispatch({
          type: CHAT_REDUCER_ACTIONS.SET_CHATS,
          payload: { ...chats, data: c },
        });
      }
      return true;
    } else {
      return false;
    }
  };

  const activateLabel = async (e, chatInfoToEdit, id) => {
    if (chat.userInfo.labels) {
      const res = await turnAbleLabel(chatInfoToEdit, id, e.checked);
      if (res) {
        if (e.checked) {
          let index = findIndexById(chats.data, chatInfoToEdit.id);
          if (index !== -1) {
            let c = [...chats.data];
            c[index].labels.push(res.changed_label);
            dispatch({
              type: CHAT_REDUCER_ACTIONS.SET_CHATS,
              payload: { ...chats, data: c },
            });

            let a = [...chat.userInfo.labels];
            a.push(res.changed_label);
            dispatch({
              type: CHAT_REDUCER_ACTIONS.SET_CHAT,
              payload: { ...chat, userInfo: { ...chat.userInfo, labels: a } },
            });
          }
        } else {
          let index = findIndexById(chats.data, chatInfoToEdit.id);
          if (index !== -1) {
            let c = [...chats.data];
            c[index].labels = c[index].labels.filter(
              (label) => label.id !== id
            );
            dispatch({
              type: CHAT_REDUCER_ACTIONS.SET_CHATS,
              payload: { ...chats, data: c },
            });

            let a = chat.userInfo.labels.filter((label) => label.id !== id);
            dispatch({
              type: CHAT_REDUCER_ACTIONS.SET_CHAT,
              payload: { ...chat, userInfo: { ...chat.userInfo, labels: a } },
            });
          }
        }
      }
    }
  };

  const saveLabel = async (newLabel, tab) => {
    const res = await saveLabels(newLabel, tab);
    if (res) {
      if (tab === "new") {
        const lbls = await getLabels();
        if (lbls) {
          dispatch({ type: CHAT_REDUCER_ACTIONS.SET_LABELS, payload: lbls });
        }
      } else {
        let _lbls = [...labels];
        const index = findIndexById(_lbls, newLabel.id);
        if (index !== -1) {
          _lbls[index] = newLabel;
          dispatch({ type: CHAT_REDUCER_ACTIONS.SET_LABELS, payload: _lbls });
        }
      }
    }
  };
  const deleteLabel = async (data) => {
    const res = await deleteLabels(data);
    if (res) {
      let lbls = labels.filter((c) => c.id !== data.id);
      dispatch({ type: CHAT_REDUCER_ACTIONS.SET_LABELS, payload: lbls });
    }
  };

  const createQuickBudget = async (
    products,
    client_data,
    metadata,
    additional_data,
    sender_id
  ) => {
    return await generateQuickBudget(
      products,
      client_data,
      metadata,
      additional_data,
      sender_id
    );
  };
  const sendQuickBudget = async (
    products,
    client_data,
    metadata,
    additional_data,
    sender_id
  ) => {
    return await createAndSendQuickBudget(
      products,
      client_data,
      metadata,
      additional_data,
      sender_id
    );
  };

  const changeDialog = (dialogName) => {
    dispatch({ type: CHAT_REDUCER_ACTIONS.CHANGE_DIALOG, payload: dialogName });
  };

  const backToChats = () => {
    chatInfoRef.current = null;
    dispatch({ type: CHAT_REDUCER_ACTIONS.CLEAR_CHAT });
    dispatch({ type: CHAT_REDUCER_ACTIONS.CLOSE_MOBILE_TAB });
  };

  useEffect(() => {
    fetchData().catch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!socketRef.current) {
      const isChatSelected = (chat_id) => {
        if (
          chat_id &&
          chatInfoRef.current?.id &&
          chatInfoRef.current.id === chat_id
        ) {
          return true;
        }
        return false;
      };

      const isChatVisibleWithAreaFilter = (chatArea) => {
        const normalizeText = (text) => {
          if (!text) return "";
          return text
            .normalize("NFD")                // separa los acentos
            .replace(/[\u0300-\u036f]/g, "") // elimina los acentos
            .trim()
            .toLowerCase();
        };

        const filterArea = normalizeText(filterSelectedRef.current?.area_name);
        const normalizedChatArea = normalizeText(chatArea);

        if (!filterArea) {
          return true;
        }

        return (
          filterArea === "all" ||
          normalizedChatArea === filterArea ||
          filterArea === 'unassigned' && normalizedChatArea === 'sin area'
        );
      };

      const isChatInUserAreas = (chatArea, assignUserId) => {
        if (
          userAreasRef.current?.some(
            (c) => c.label.toLowerCase() === chatArea.toLowerCase()
          ) ||
          chatArea === "Sin Área" ||
          chatArea === ""
        ) {
          // no operario
          if (userRole.id !== 4) {
            return true;
          }
          //operario
          if (
            userRole.id === 4 &&
            (assignUserId === "" ||
              assignUserId === null ||
              userContactRef.current?.id === assignUserId)
          ) {
            return true;
          }
        }
        return false;
      };

      const socket = io(WS_URL, {
        transports: ["websocket"],
        cors: {
          origin: "http://localhost:3000",
        },
      });
      socketRef.current = socket;
      socket.on("connect", () => {
        console.log("CONNECT");
        socket.emit("join_room", {
          bot_id: Number(localStorage.getItem("bot")),
        });
      });

      socket.on("disconnect", (data) => {
        console.log("DISCONNECT", data);
      });

      socket.on(`message`, (data) => {
        if (
          isChatInUserAreas(data.conversation.area, data.conversation.assigned_user_id)
          && isChatVisibleWithAreaFilter(data.conversation.area)
        ) {
          if (isChatSelected(data?.conversation?.id)) {
            dispatch({
              type: CHAT_REDUCER_ACTIONS.ADD_NEW_MESSAGE,
              payload: data,
            });
            dispatch({
              type: CHAT_REDUCER_ACTIONS.UPDATE_USER_INFO,
              payload: {
                // allowed_messages: data.conversation?.allowed_messages,
                template_window: data.conversation?.template_window,
                conversation_active: data.conversation?.conversation_active || true,
                employee:
                  data.conversation.assign_user || "Sín usuario asignado",
              },
            });
            dispatch({
              type: CHAT_REDUCER_ACTIONS.UPDATE_CHAT_INFO,
              payload: {
                live: data.conversation.live,
              },
            });
          }
          dispatch({
            type: CHAT_REDUCER_ACTIONS.ADD_NEW_CHAT,
            payload: {
              ...data.conversation,
              messageFrom: data.message.type,
            },
          });
        } else {
          // filter chat if is assigned when sending message
          dispatch({
            type: CHAT_REDUCER_ACTIONS.DELETE_CHAT_IN_MENU,
            payload: data.conversation,
          });
        }
      });

      socket.on(`conversation`, (data) => {
        // console.log("NEW CONVERSATION:", data);
        if (
          isChatInUserAreas(data.conversation.area, "") &&
          isChatVisibleWithAreaFilter(data.conversation.area)
        ) {
          if (categoryRef.current === CHAT_CATEGORIES.CHATS) {
            dispatch({
              type: CHAT_REDUCER_ACTIONS.ADD_NEW_CHAT,
              payload: {
                ...data.conversation,
              },
            });
          }
        }
      });

      socket.on(`change-inbox`, (data) => {
        if (
          isChatInUserAreas(data.conversation.area, data.conversation.assigned_user_id) &&
          isChatVisibleWithAreaFilter(data.conversation.area)
        ) {
          dispatch({
            type: CHAT_REDUCER_ACTIONS.UPDATE_FILTER_CHATS_IN_MENU,
            payload: { ...data.conversation },
          });
        }
      });

      socket.on(`close-conversation`, (data) => {
        console.log("CLOSE CONVERSATION:", data);
        if (
          isChatInUserAreas(data.conversation.area, data.conversation.assigned_user_id) &&
          isChatVisibleWithAreaFilter(data.conversation.area)
        ) {
          dispatch({
            type: CHAT_REDUCER_ACTIONS.SET_CLOSED_CHAT,
            payload: { ...data.conversation },
          });
        }
      });

      socket.on('change-score', (data) => {
        // console.log('Nuevo score:', data.conversation.lead_score);
        dispatch({
          type: CHAT_REDUCER_ACTIONS.SET_LEAD_QUALITY_SCORE,
          payload: data.conversation.lead_score,
        });
      });

      // socket.on('new-contact', (data) => {
      //   // console.log("NEW CONTACT:", data);
      //   const contact = data?.data;
      //   if (!contact?.id) return;
      //   dispatch({
      //     type: CHAT_REDUCER_ACTIONS.ADD_NEW_CONTACT,
      //     payload: mapContactToOption(contact),
      //   });
      // });

      socket.on(`change-area`, (data) => {
        console.log("NEW CHANGE AREA:", data);
        if (isChatInUserAreas(data.conversation.area, "")) {
          if (isChatSelected(data?.area?.live_chat_id)) {
            dispatch({
              type: CHAT_REDUCER_ACTIONS.UPDATE_CHAT_INFO,
              payload: {
                area: data.area.area_name,
                assign_user: "",
                open: data.area.open,
              },
            });
            getAreasAndContacts({ contact_data: data.area });
            dispatch({
              type: CHAT_REDUCER_ACTIONS.UPDATE_USER_INFO,
              payload: {
                area: data.area.area_name,
                area_id: data.area.area_id,
                employee: "Sín usuario asignado",
                employee_id: null,
              },
            });
          }
          dispatch({
            type: CHAT_REDUCER_ACTIONS.UPDATE_FILTER_CHATS_IN_MENU,
            payload: {
              ...data.conversation,
              area: data.area.area_name,
              assign_user: "",
              open: data.area.open,
            },
          });
        } else {
          dispatch({
            type: CHAT_REDUCER_ACTIONS.DELETE_CHAT_IN_MENU,
            payload: data.conversation,
          });
        }
      });

      socket.on(`assign-user`, (data) => {
        if (
          isChatInUserAreas(data.conversation.area, data.conversation.assigned_user_id)
        ) {
          if (isChatSelected(data?.assigned_user?.live_chat_id)) {
            dispatch({
              type: CHAT_REDUCER_ACTIONS.UPDATE_CHAT_INFO,
              payload: {
                assign_user: data.assigned_user.username,
              },
            });
            dispatch({
              type: CHAT_REDUCER_ACTIONS.UPDATE_USER_INFO,
              payload: {
                employee: data.assigned_user.username || "Sín usuario asignado",
                employee_id: data.assigned_user.user_id,
              },
            });
          }
          dispatch({
            type: CHAT_REDUCER_ACTIONS.UPDATE_FILTER_CHATS_IN_MENU,
            payload: {
              ...data.conversation,
              assign_user: data.assigned_user.username,
            },
          });
        } else {
          dispatch({
            type: CHAT_REDUCER_ACTIONS.DELETE_CHAT_IN_MENU,
            payload: data.conversation,
          });
        }
      });

      socket.on(`status`, (data) => {
        if (isChatSelected(data?.status?.live_chat_id)) {
          dispatch({
            type: CHAT_REDUCER_ACTIONS.UPDATE_MESSAGE_STATUS,
            payload: {
              message_status_obj: {
                code: data.status.code,
                last_update_status_date: data.status.last_update_status_date,
                last_update_status_time: data.status.last_update_status_time,
                message_status: data.status.message_status
              },
              live_chat_id: data.status.live_chat_id,
              message_id: data.status.message_id
            },
          });
        }
      });

      socket.on(`reaction`, (data) => {
        // console.log("NEW REACTION:", data);
        if (isChatSelected(data?.reaction_object?.live_chat_id)) {
          dispatch({
            type: CHAT_REDUCER_ACTIONS.UPDATE_MESSAGE,
            payload: {
              message_id: data.reaction_object.message_id,
              data: { reaction: data.reaction_object.emoji },
            },
          });
        }
        dispatch({
          type: CHAT_REDUCER_ACTIONS.UPDATE_CHAT_IN_MENU,
          payload: data?.conversation,
        });
      });

      socket.on(`labels`, (data) => {
        // console.log("NEW LABELS:", data);
        if (isChatSelected(data?.labels?.live_chat_id)) {
          dispatch({
            type: CHAT_REDUCER_ACTIONS.UPDATE_USER_INFO,
            payload: { labels: data.labels.labels },
          });
        }
        dispatch({
          type: CHAT_REDUCER_ACTIONS.UPDATE_CHAT_IN_MENU,
          payload: {
            id: data.labels.live_chat_id,
            labels: data.labels.labels,
          },
        });
      });

      socket.on(`change-username`, (data) => {
        // console.log("CHANGE USERNAME:", data);
        if (isChatSelected(data?.username?.live_chat_id)) {
          dispatch({
            type: CHAT_REDUCER_ACTIONS.UPDATE_CHAT_INFO,
            payload: {
              user_name: data.username.username,
            },
          });
          dispatch({
            type: CHAT_REDUCER_ACTIONS.UPDATE_USER_INFO,
            payload: {
              name: data.username.username,
            },
          });
        }
        dispatch({
          type: CHAT_REDUCER_ACTIONS.UPDATE_CHAT_IN_MENU,
          payload: {
            id: data.username.live_chat_id,
            user_name: data.username.username,
          },
        });
      });

      socket.on(`internal-message`, (data) => {
        // console.log("INTERNAL CHAT MESSAGE:", data);
        if (isChatSelected(data?.internal_message?.live_chat_id)) {
          dispatch({
            type: CHAT_REDUCER_ACTIONS.ADD_NEW_MESSAGE,
            payload: { message: data.internal_message },
          });
        }
      });

      socket.on(`set-unread`, (data) => {
        // console.log("TOGGLE READ:", data);
        if (isChatSelected(data?.conversation?.live_chat_id)) {
          dispatch({
            type: CHAT_REDUCER_ACTIONS.UPDATE_CHAT_INFO,
            payload: {
              open: data?.conversation?.open,
            },
          });
        }
        dispatch({
          type: CHAT_REDUCER_ACTIONS.UPDATE_CHAT_IN_MENU,
          payload: {
            id: data.conversation.live_chat_id,
            open: data?.conversation?.open,
          },
        });
      });

      socket.on(`quick-reply`, (event) => {
        // console.log("QUICK REPLY EVENT DATA:", event);
        const quick_reply = event?.data?.quick_reply;
        switch (event?.data?.event_type) {
          case "add":
            quickReplyStore.add(quick_reply);
            break;

          case "edit":
            quickReplyStore.update(quick_reply);
            break;

          case "delete":
            quickReplyStore.remove(quick_reply.id);
            break;
        }
      });

      socket.on(`quick-reply-order`, (event) => {
        // console.log("QUICK REPLY EVENT DATA:", event);
        quickReplyStore.setQuickReplies(event?.data);
      });

      socket.on(`area`, (event) => {
        // console.log("AREAS EVENT DATA:", event);
        const area = event?.data?.area;
        switch (event?.data?.event_type) {
          case "add":
            areasWithUsersStore.addArea(area);
            break;

          case "edit":
            areasWithUsersStore.updateArea(area.id, area);
            break;

          case "delete":
            areasWithUsersStore.removeArea(area.id);
            break;
        }
      });

      socket.on(`user-area`, (event) => {
        // console.log("USER AREA EVENT DATA:", event);
        const user = event?.data?.user;
        const area_id = event?.data?.area_id;

        switch (event?.data?.event_type) {
          case "add":
            areasWithUsersStore.addUserToArea(area_id, user);
            break;

          case "delete":
            areasWithUsersStore.removeUserFromArea(area_id, user.id);
            break;
        }
      });

      socket.on(`contact`, (event) => {
        // console.log("CONTACT EVENT DATA:", event);
        const contact = event?.data?.contact;
        switch (event?.data?.event_type) {
          case "add":
            contactStore.add(contact);
            break;

          case "edit":
            contactStore.update(contact);
            break;

          case "delete":
            contactStore.remove(contact.id);
            break;
        }
      });

      socket.on(`toggle-answered`, (data) => {
        // console.log("TOGGLE ANSWERED:", data);
        if (isChatSelected(data?.conversation?.live_chat_id)) {
          dispatch({
            type: CHAT_REDUCER_ACTIONS.UPDATE_CHAT_INFO,
            payload: {
              answered: data?.conversation?.answered,
            },
          });
        }
        dispatch({
          type: CHAT_REDUCER_ACTIONS.UPDATE_CHAT_IN_MENU,
          payload: {
            id: data.conversation.live_chat_id,
            answered: data?.conversation?.answered,
          },
        });
      });

      socket.on(`reactivate`, (data) => {
        // console.log("REACTIVATE CHAT:", data);
        if (isChatSelected(data?.conversation?.live_chat_id)) {
          dispatch({
            type: CHAT_REDUCER_ACTIONS.UPDATE_CHAT_INFO,
            payload: {
              live: data.conversation.live,
            },
          });
        }
        dispatch({
          type: CHAT_REDUCER_ACTIONS.UPDATE_CHAT_IN_MENU,
          payload: {
            id: data.conversation.live_chat_id,
            live: data.conversation.live,
          },
        });
      });

      return function cleanup() {
        if (socketRef.current) {
          socketRef.current?.disconnect();
          socketRef.current = null;
        }
      };
    }
  }, []);

  return {
    chatState,
    selectChat,
    selectCategory,
    reactivateBot,
    changeCategory,
    renameChat,
    saveChangeArea,
    saveChangeContact,
    saveReassignChat,
    activateLabel,
    addChatComment,
    shareChatToContact,
    checkUnreadChat,
    checkAnsweredChat,
    exportChatLeads,
    downloadSelectedChat,
    filterChats,
    removeFilter,
    initNewChat,
    backToChats,
    changeChatInfo,
    loadNewChatPage,
    changeDialog,
    sendNewChatMessage,
    saveQuickReply,
    saveQuickReplyOrder,
    deleteQuickReply,
    saveLabel,
    deleteLabel,
    createQuickBudget,
    sendQuickBudget,
    saveDefaultFilters,
    toggleLabelActionStatus,
    handleGetScoreChat,
    handleSaveScoreChat,
    scoreChat,
    setScoreChat,
    userAreas,
    addLeadQualityScore,
    generateChatSummary,
    adsList,
    campaignsList,
    closeChat,
    saveContact,
    retryFailedMessage,
    getContactDataRequest,
    getContactVariablesRequest
  };
}
